import React from 'react'
import ApiFetcher from 'lib/api_fetcher'
import paymentRedirect from 'lib/payment_redirect'
import {Button} from 'reactstrap'
import { useTranslation } from 'react-i18next'
import cartFailed from 'img/cart-failed'
import gearLoading from 'img/gear-loading'

const PaymentStripeCallout = ({cart, endpoint, paymentUrl}) => {
  const { t, i18n } = useTranslation()

  const paymentReturnUrl = cart?.payment_request?.redirect_url

  console.log(cart)

  return (
    <React.Fragment>
      <div className="alert alert-warning mb-4 d-flex flex-column flex-md-row justify-content-start" role="alert">
        <div className="text-center me-md-4">
          <img width="110" height="110" className="me-3" src={gearLoading} alt="Pago en proceso" />
        </div>
        <div className="w-100 mt-3 mt-md-0">
          <div className="alert-heading d-flex flex-column flex-md-row justify-content-between m-0 p-0">
            <div className="align-self-center">
              <h5 className="alert-heading">{i18n.t('payment_stripe_callout.payment_stripe_title')}</h5>
              <p className="m-0">{i18n.t('payment_stripe_callout.payment_stripe_description')}</p>
            </div>
            <div className="text-center mt-3 mt-md-0">
              {paymentReturnUrl &&
                <Button
                  color="warning"
                  onClick={() => window.location.href = paymentReturnUrl}
                >
                  {i18n.t('payment_stripe_callout.go_to_payment_gateway_button')}
                </Button>              
              }

            </div>
          </div>
          <hr/>
          <h4 className="m-0">{cart.payment_response}</h4>
        </div>
      </div>
    </React.Fragment>
  )
}

export default PaymentStripeCallout